import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { OnboardingDataResponse } from "@src/types/onboardingDataResponse";
import { VideoPlayer } from "expo-video";
import { RefObject } from "react";

export const imageTypes = ["png", "gif", "jpg", "jpeg", "webp", "bmp"];
export const videoTypes = ["mp4", "mov", "wmv"];

export type OnboardingScreenProps = {
  onboardingData?: OnboardingDataResponse[];
  isPostOnboarding?: boolean;
  fromLogin?: boolean;
};

export type ButtonAction = {
  type: ButtonType;
  title: string;
  onPressAction: (shouldLogout?: boolean) => void;
};

export type BottomButtonsProps = {
  activeNavigationIndex: number;
  onboardingDataState: OnboardingDataResponse[];
  toRegisterScreen: () => void;
  toLoginScreen: () => void;
  buttonCategory: typeof ButtonCategory;
  buttonType: typeof ButtonType;
  isPostOnboarding?: boolean;
  skipToAppNavigator: () => void;
  goToAppNavigator: () => void;
  goToPreviousScreen: () => void;
  goToNextScreen: () => void;
  isButtonLoading?: boolean;
  isButtonDisabled?: boolean;
};

export type CarouselItemProps = {
  mediaItem: OnboardingDataResponse;
  index: number;
  videoPlayers: RefObject<(VideoPlayer | null)[]>;
  typography: any;
  theme: any;
  isPostOnboarding?: boolean;
  onVideoLoad?: (index: number) => void;
};
